import React, { useState } from "react";
import Modal from "../../../../../components/modal";
import Button from "../../../../../components/new-button";
import { DeleteMember } from "../../../../../../api";
import styles from "./styles.module.scss";
import toast from "react-hot-toast";
import useOrganizationStore from "../../../../../stores/organization";

const RemoveMember = ({ open, onClose, memberId }) => {
  const [submitting, setSubmitting] = useState(false);
  const selectedOrganizationId = useOrganizationStore(
    (state) => state.selectedOrganizationData?.organization?.id,
  );
  const setSelectedOrganizationData = useOrganizationStore(
    (state) => state.setSelectedOrganizationData,
  );
  const remove = async () => {
    setSubmitting(true);
    const data = {
      user_id: memberId,
      organization_id: selectedOrganizationId,
    };

    try {
      const response = await DeleteMember(data);
      if (!response?.success) {
        toast.error("There was a problem removing the member", { duration: 5000 });
        console.error("There was a problem removing the member");
        console.error(response.message);
      }

      if (response.success) {
        setSelectedOrganizationData((prev) => ({
          ...prev,
          users: response.users,
        }));
        toast.success("Member removed successfully", { duration: 5000 });
        if (response?.subAgentAttempted && !response?.subAgentStatus) {
          toast.error(`SubAgent Deletion API request failed: ${response.subAgentResponseMessage}`, { icon: "🚨", duration: 30000 });
        }
        onClose();
      }
    } catch (error) {
      toast.error("There was a problem removing the member", { duration: 5000 });
      console.error("There was a problem removing the member");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      header="Are you sure want to remove this user? You cannot undo this action."
      headingCenteredSpaced
      isOpen={open}
      onClose={onClose}
    >
      <div className={styles.actionWrapper}>
        <div className={styles.button_group}>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={remove} disabled={submitting}>
            Remove
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveMember;
